import autosize from "@/helpers/autosize.coffee"
export default
  autosize: (id) ->
    if id == undefined
      autosize.autosizeClass()
    else
      autosize.autosizeId(id)
  autosizeClass: ->
    debug = false
    elements = document.getElementsByClassName('autosize')
    elements = Array.from(elements)
    if debug
      console.info 'autosize', 'elements', elements.length
    if elements.length <= 0
      return
    elements.forEach (element, i) ->
      autosize.autosizeElement(element)
  autosizeId: (id) ->
    element = document.getElementById(id)
    if element == undefined
      return
    if element == null
      return
    autosize.autosizeElement(element, id)
  autosizeElement: (element, id) ->
    # Don't bother with invisible elements.
    reduceFont = true
    if element.offsetWidth < 350
      reduceFont = false
    if (element.offsetWidth <= 0 || element.offsetHeight <= 0)
      return

    tries = 64 # number of tries, equal to 32 pixels of shrink.
    ratio = 0.5 # Amount to reduce the font by each try.
    minimum = 13 # minimum font size

    # Store the initial size to restore on change.
    elementStyle = window.getComputedStyle(element)
    initialSize = elementStyle.getPropertyValue('font-size')
    if !(element.hasAttribute('data-autosize-initial-font-size'))
      element.setAttribute('data-autosize-initial-font-size', initialSize)
    if !(element.getAttribute('data-autosize-initial-font-size') == initialSize)
      element.style.fontSize = element.getAttribute('data-autosize-initial-font-size')

    q = 0 # Bailout counter, need to determine why inf loop. For now best-effort.
    while ((element.scrollWidth > element.offsetWidth || element.scrollHeight > element.offsetHeight) && (q < tries))
      q++
      oldFontSize = elementStyle.getPropertyValue('font-size')
      floatFontSize = parseFloat(oldFontSize)
      if floatFontSize > minimum
        fontUnit = oldFontSize.replace(floatFontSize, '')
        newFontSize = (floatFontSize - ratio) + "" + fontUnit
        element.style.fontSize = newFontSize
        element.setAttribute('data-autosize-font-size', newFontSize)
    while ((element.scrollWidth ==  0 || element.scrollHeight == 0) && reduceFont == true && (q < tries))
      q++
      oldFontSize = elementStyle.getPropertyValue('font-size')
      floatFontSize = parseFloat(oldFontSize)
      if floatFontSize > minimum
        fontUnit = oldFontSize.replace(floatFontSize, '')
        newFontSize = (floatFontSize - ratio) + "" + fontUnit
        element.style.fontSize = newFontSize
        element.setAttribute('data-autosize-font-size', newFontSize)
  enableAutoSize: (id) ->
    autosize.autosize(id)
    window.addEventListener 'resize', ->
      autosize.autosize(id)
